// extracted by mini-css-extract-plugin
module.exports = {"bioDetail":"Bio_bioDetail__jKAMk"};